import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { Router } from '@angular/router';
import { BehaviorSubject, throwError } from 'rxjs';
import { filter, take, switchMap, finalize } from 'rxjs/operators';


@Injectable()
export class RequestInterceptor implements HttpInterceptor {


  private refreshTokenInProgress = false;
  private refreshTokenSubject = new BehaviorSubject<boolean | null>(null);

  constructor(public auth: AuthService, private router: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    request = this.addAuthenticationToken(request);

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        //console.log('Interceptor caught error:', error.status, request.url);
        if (error && error.status === 401) {
          //console.log('Handling 401...');
          return this.handle401(request, next);
        } else {
          return throwError(error);
        }
      })
    );
  }

handle401(request: HttpRequest<any>, next: HttpHandler) {
    if (this.refreshTokenInProgress) {
        return this.refreshTokenSubject.pipe(
            filter(result => result !== null),
            take(1),
            switchMap(() => next.handle(this.addAuthenticationToken(request)))
        );
    } else {
        this.refreshTokenInProgress = true;
        this.refreshTokenSubject.next(null);

        return this.auth.refreshAccessToken2().pipe(
            switchMap((success: boolean) => {
               //console.log('Refresh succeeded:', success);
                this.refreshTokenSubject.next(success);
                return next.handle(this.addAuthenticationToken(request));
            }),
            catchError((error) => {
              //console.log('Refresh failed:', error.status);
                this.refreshTokenSubject.next(null);
                this.auth.logout();
                return throwError(() => error);
            }),
            finalize(() => this.refreshTokenInProgress = false)
        );
    }
}

  private addAuthenticationToken(request: HttpRequest<any>): HttpRequest<any> {

     const token = this.auth.getToken();
    
    if (!token) {
        return request;
    }

    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${this.auth.getToken()}`
      }
    });
  }
}
